<template>
	<button
		v-show="showBtn"
		type="button"
		:class="[btnClass]"
		@click="handleSearchOpen()"
		aria-label="Open Product Search"
		class="w-5 h-5 flex items-center justify-center"
	>
		<svg-vue icon="search-md" class="w-6 h-6 md:w-5 md:h-5 overflow-visible" />
	</button>
</template>
<script setup>
import { onMounted, onUnmounted, computed } from 'vue'
import { storeToRefs } from 'pinia'

import { useAppStore } from '@stores'

const props = defineProps({
	btnClass: {
		type: String,
		default: '',
	},
})

const appStore = useAppStore()
const { searchOpen, isLargeMediaQuery } = storeToRefs(appStore)
const { openSearch } = appStore

onMounted(() => document.addEventListener('keydown', handleKeydown))
onUnmounted(() => document.removeEventListener('keydown', handleKeydown))

const showBtn = computed(() => {
	if (!isLargeMediaQuery.value && searchOpen.value) {
		return false
	}
	return true
})

const handleKeydown = (e) => {
	if (e.metaKey && e.key === 'k') {
		handleSearchOpen()
	}
}
const handleSearchOpen = () => openSearch()
</script>
